import React from "react";
import { Skeleton } from "antd";

import { Container } from "./styles";

const SkeletonLabel = ({ width = "60%" }) => {
  return (
    <Container>
      <Skeleton active title={false} paragraph={{ rows: 1, width }} />
    </Container>
  );
};

export default SkeletonLabel;
